export enum MomentTransformType {
    ToGregorianIsoStringFormat,
    ToGregorianUtcIsoStringFormat,
    
    ToGregorianIsoStringFormatFromHijri,
    ToGregorianUtcIsoStringFormatFromHijri,

    ToGregorianCalendarUtcDateObjectFromIsoString,
    ToGregorianCalendarDateObjectFromIsoString,

    ToHijriIsoStringFormat,
    ToHijriUtcIsoStringFormat,
    ToHijriIsoStringFormatFromGregorian,
    ToHijriUtcIsoStringFormatFromGregorian,

    ToHijriCalendarUtcDateObjectFromIsoString,
    ToHijriCalendarDateObjectFromIsoString,
}